// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__idkpv","input":"styles_input__3EdkC"};